
// @ts-nocheck
import {defineComponent} from "vue";
import Swal from "sweetalert2";
import FormInput from "./FormInput.vue";
import AddressFields from "./AddressFields.vue";

interface Plan {
  id_plano: number;
  codigo_plano: string;
  nome_plano: string;
  valor_mensal: string;
  valor_anual: string;
  designacao_html: string;
  extensao: string;
}

export default defineComponent({
  name: "CreateCompanyForm",
  components: { FormInput, AddressFields },
  data() {
    return {
      dadosEmpresa: {
        alias_goldylocks: "",
        email: "",
        nome_goldylocks: "",
        morada_goldylocks: "",
        cp_goldylocks: "",
        localidade_goldylocks: "",
        nif_goldylocks: "",
        plan_id: 0
      },
      currentStep: 1,
      isCreating: false,
      isLoadingPlans: false,
      plansLoadError: false,
      plans: [] as any[],
    }
  },
  computed: {
    onlyPlans() {
      return this.plans.filter(plan => plan['extensao'] === "0");
    },
    selectedPlanInfo(): Plan | null {
      const selectedPlan = this.onlyPlans.filter(plan => plan['id_plano'] === this.dadosEmpresa.plan_id);
      return selectedPlan.length > 0 ? selectedPlan[0] : null;
    },
    isFormValid() {
      return this.isAliasValid &&
             this.isNifValid &&
             /^\d{4}-\d{3}$/.test(this.dadosEmpresa.cp_goldylocks) &&
             /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.dadosEmpresa.email) &&
             this.dadosEmpresa.nome_goldylocks.length >= 2 &&
             this.dadosEmpresa.morada_goldylocks.length >= 5 &&
             this.dadosEmpresa.localidade_goldylocks?.length >= 2 &&
             this.dadosEmpresa.plan_id > 0 &&
             !this.plansLoadError &&
             !this.isLoadingPlans;
    },
    isNifValid() {
      return /^\d{9}$/.test(this.dadosEmpresa.nif_goldylocks);
    },
    isAliasValid() {
      return /^[a-zA-Z0-9_-]{3,50}$/.test(this.dadosEmpresa.alias_goldylocks);
    },
    canProceed() {
      if (this.currentStep === 1) {
        return this.isNifValid && this.isAliasValid && 
               this.dadosEmpresa.nome_goldylocks.length >= 2 &&
               this.dadosEmpresa.morada_goldylocks.length >= 5;
      }
      if (this.currentStep === 2) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.dadosEmpresa.email);
      }
      return true;
    }
  },
  methods: {
    sanitizeTextInput(input: string): string {
      if (!input) return input;
      return input
        .replace(/[<>'"&]/g, '')
        .replace(/javascript:/gi, '')
        .replace(/vbscript:/gi, '')
        .replace(/on\w+\s*=/gi, '')
        .substring(0, 255);
    },
    validateNifInput(event: Event) {
      const target = event.target as HTMLInputElement;
      target.value = target.value.replace(/\D/g, '');
      this.dadosEmpresa.nif_goldylocks = target.value;
    },
    validateAliasInput(event: Event) {
      const target = event.target as HTMLInputElement;
      let value = target.value.replace(/[^a-zA-Z0-9_-]/g, '');
      value = this.sanitizeTextInput(value).substring(0, 50);
      target.value = value;
      this.dadosEmpresa.alias_goldylocks = value;
    },
    nextStep() {
      if (this.canProceed && this.currentStep < 3) {
        this.currentStep++;
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    createGoldylocks() {
      if (this.isFormValid) {
        this.isCreating = true;
        this.$store.dispatch('createNewCompany', this.dadosEmpresa)
          .then(() => {
            this.isCreating = false;
            this.dadosEmpresa = {
              alias_goldylocks: "",
              email: "",
              nome_goldylocks: "",
              morada_goldylocks: "",
              cp_goldylocks: "",
              localidade_goldylocks: "",
              nif_goldylocks: "",
              plan_id: 0
            };
            this.currentStep = 1;
            Swal.fire({
              icon: `success`,
              html: `Pedido de criação submetido com <strong>sucesso</strong>!<br><span>Receberá um email com as credenciais de acesso dentro de momentos.</span>`,
              showConfirmButton: true,
              showCancelButton: false,
              confirmButtonText: `OK`,
              confirmButtonColor: `#3ec487`,
            });
          })
          .catch(() => {
            this.isCreating = false;
          });
      }
    },
    fetchPlans() {
      this.isLoadingPlans = true;
      this.plansLoadError = false;
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('Timeout')), 10000);
      });
      Promise.race([this.$store.dispatch('fetchPlans'), timeoutPromise])
        .then(plans => {
          this.plans = plans;
          this.plansLoadError = false;
        })
        .catch((error: any) => {
          console.error('Erro ao carregar planos:', error);
          this.plansLoadError = true;
        })
        .finally(() => {
          this.isLoadingPlans = false;
        });
    }
  },
  mounted() {
    this.fetchPlans();
  }
});
